require('../RAProjectionChartCustomTick.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
// @ utilities
import { formatText } from 'core/i18n';
const { toCamelCase } = require('utilities/stringHelper');
// @ constants
const {
    LINE_LABEL_COLOR,
    OBJECTIVE_LABEL,
    REF_DOT_STROKE_COLOR,
    TICK_BUTTON_BORDER_COLOR,
    TICK_DISABLED_COLOR,
    TICK_TEXT_COLOR,
    TODAY_LABEL,
} = require('constants/RAConstants/RAObjectiveTracking');
import { getDateWithOffset, formatDateToMMMD, formatDateToMMMYYYY } from 'utilities/dateHelper/dateHelper';

class RACustomTickWithObjective extends React.Component {
    render() {
        const {
            payload,
            x,
            y,
            disabled,
            onObjectiveClick,
            tickInfo,
            activeButtonLabel,
            showPointsList,
            noOfChartPoints,
        } = this.props;
        const borderColor = disabled ? TICK_DISABLED_COLOR : TICK_BUTTON_BORDER_COLOR;
        const textColor = disabled ? TICK_DISABLED_COLOR : TICK_TEXT_COLOR;
        let customTickContent = null;

        if (payload.value === 0) {
            customTickContent = (
                <g>
                    <rect
                        x={x - 25}
                        y={y - 4}
                        width="50"
                        height="33"
                        rx="15"
                        ry="15"
                        stroke={activeButtonLabel === TODAY_LABEL ? LINE_LABEL_COLOR : borderColor}
                        fill={activeButtonLabel === TODAY_LABEL ? LINE_LABEL_COLOR : 'none'}
                    />
                    <text
                        x={x}
                        y={y + 16}
                        fill={activeButtonLabel === TODAY_LABEL ? REF_DOT_STROKE_COLOR : textColor}
                        textAnchor="middle"
                        className="ra-projection-custom-tick__button"
                    >
                        {formatText('rentabilityGraph-today')}
                    </text>
                </g>
            );
        } else if (payload.value === noOfChartPoints - 1) {
            customTickContent = (
                <g>
                    <rect
                        x={x - 40}
                        y={y - 4}
                        width="80"
                        height="33"
                        rx="15"
                        ry="15"
                        stroke={activeButtonLabel === OBJECTIVE_LABEL ? LINE_LABEL_COLOR : borderColor}
                        fill={activeButtonLabel === OBJECTIVE_LABEL ? LINE_LABEL_COLOR : 'none'}
                    />
                    <text
                        x={x}
                        y={y + 16}
                        fill={activeButtonLabel === OBJECTIVE_LABEL ? REF_DOT_STROKE_COLOR : textColor}
                        textAnchor="middle"
                        onClick={onObjectiveClick}
                        className="ra-projection-custom-tick__button"
                    >
                        {formatText('raObjectiveTracking-objectiveText')}
                    </text>
                </g>
            );
        } else if (showPointsList.indexOf(payload.value) !== -1) {
            const daysDiff = payload.value * tickInfo;
            const newDate = getDateWithOffset(new Date(), { days: daysDiff });
            const dayMonth = formatDateToMMMD(newDate);
            const monthYear = formatDateToMMMYYYY(newDate);
            const showDate = daysDiff > 55 ? monthYear : dayMonth;

            customTickContent = (
                <text
                    x={x - 20}
                    y={y + 10}
                    fill={textColor}
                    textAnchor="left"
                    className="ra-projection-custom-tick__date"
                >
                    <tspan x={x - 20} y={y + 10}>
                        <tspan x={x - 20} y={y + 10}>
                            {showDate && toCamelCase(showDate).replace('.', '')}
                        </tspan>
                    </tspan>
                </text>
            );
        }

        return customTickContent;
    }
}

RACustomTickWithObjective.propTypes = {
    activeButtonLabel: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    noOfChartPoints: PropTypes.number.isRequired,
    onObjectiveClick: PropTypes.func,
    payload: PropTypes.object.isRequired,
    showPointsList: PropTypes.array.isRequired,
    tickInfo: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
};

RACustomTickWithObjective.defaultProps = {
    activeButtonLabel: '',
};

module.exports = RACustomTickWithObjective;
